import { render, staticRenderFns } from "./dataBox1.vue?vue&type=template&id=24ea1226&scoped=true&"
import script from "./dataBox1.vue?vue&type=script&lang=ts&"
export * from "./dataBox1.vue?vue&type=script&lang=ts&"
import style0 from "./dataBox1.vue?vue&type=style&index=0&id=24ea1226&scoped=true&lang=scss&"
import style1 from "./dataBox1.vue?vue&type=style&index=1&id=24ea1226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea1226",
  null
  
)

export default component.exports